export { TrieMap, defTrieMap, defTrieMapFromJSON } from "@thi.ng/trie";
export type { SerializedTrieMap } from "@thi.ng/trie";
